export default "__VITE_PUBLIC_ASSET__492cd1ce__"